import type { AxiosRequestConfig } from "axios";
import { KEYS } from "../const";

export function checkAuthConfig(config?: AxiosRequestConfig) {
  if (config === undefined || config === null) config = {};
  config[KEYS.CONFIG.AUTH] = true;
  return config;
}
